import React from 'react';

interface PriceHeroProps {
  metaLine: string;
  pair: string;
  timeframe: string;
  priceMajor: string;
  priceCents: string;
  isBull: boolean;
  onOpenPair: (anchor: HTMLElement) => void;
  onOpenTf: (anchor: HTMLElement) => void;
}

/** Price hero: meta line, pair/TF pills, big price, bull/bear tag. */
export function PriceHero({
  metaLine,
  pair,
  timeframe,
  priceMajor,
  priceCents,
  isBull,
  onOpenPair,
  onOpenTf,
}: PriceHeroProps) {
  return (
    <div className="price-hero">
      <div className="hero-row1">
        <span className="pmeta">{metaLine}</span>
        <div className="pills-row">
          <button className="pill" onClick={(e) => onOpenPair(e.currentTarget)} type="button">
            <span className="pill-text">{pair}</span>
            <span className="pill-caret">▾</span>
          </button>
          <button className="pill" onClick={(e) => onOpenTf(e.currentTarget)} type="button">
            <span className="pill-text">{timeframe}</span>
            <span className="pill-caret">▾</span>
          </button>
        </div>
      </div>

      <div className="hero-row2">
        <div className="price-block">
          <span className="price-major">{priceMajor}</span>
          <span className="price-cents">{priceCents}</span>
        </div>
        <div className={`bull-tag${isBull ? '' : ' bear-tag'}`}>
          <span className={`bull-tag-text${isBull ? '' : ' bear-tag-text'}`}>
            {isBull ? '↑ Bull' : '↓ Bear'}
          </span>
        </div>
      </div>
    </div>
  );
}
